import { GitHub, Instagram, Linkedin, Twitter } from "assets/icons";

export const NavItems = [
	{
		name: "About Me",
		url: "about",
	},
	{
		name: "Experience",
		url: "experience",
	},
	{
		name: "Projects",
		url: "projects",
	},
	{
		name: "Contact",
		url: "contact",
	},
];


export const Works = [
	{
		company: "IBO",
		company_url: "https://www.linkedin.com/company/ebo-mart-private-limited/mycompany/",
		position: "SDE-1",
		start_date: "August 2022",
		end_date: "Present",
		description: [
			'Created whole customer onboarding process replacing third party application Bizom.',
            'Contributed in payment services where all types of payment method got integrated.',
			'Contributed in creating cashback and referral amount credit and debit process for specific customers',
			'Integrated apis with Third party ERPs like Odoo,Magento and Moengage',
			'Created customer calling feature for offline stores to create lead or followups',
			'Have done end to end unit testing with jest'


		],
	},
	{
		company: "Masai School",
		company_url: "https://www.linkedin.com/school/masai-school/mycompany/",
		position: "Instructional Associate",
		start_date: "December 2021",
		end_date: "July 2022",
		description: [
			'Solving the Doubts of Students in DSA and Coding.',
            'Helped Students in creating and cloning more than 100  Projects.'
		],
	},

];

const images = {
	zara: "ZARA",
	coursera: "coursera",
	beautybebo:"Beautybebo",
	modesens:"modesens"
	
};

export const CardProjects = [
	
	{
		name: "Modesens.com",
		description: (
			<p>
				 ModeSens is a eCommerce website which me and my friends have cloned using react ,express ,mongodb.We have added product desription page ,
				 drodown menu ,search box etc.
			</p>
		),
		tools: ['REACT','REDUX','MONGODB','EXPRESS','NODE','TAILWIND','STYLED-COMPONENT'],
		link: "https://modesense.netlify.app/",
		github: "https://github.com/Anmolroan/Modesens-Clone",
		images: {
			sm: require(`assets/images/${images.modesens}.jpg`),
			md: require(`assets/images/${images.modesens}.jpg`),
			lg: require(`assets/images/${images.modesens}.jpg`),
		},
	},
	
	{
		name: "ZARA.com",
		description: (
			<p>
				 It is an e-commerce website having varieties of luxury items which are of high quality. We have tried to clone the pixel perfect website with the help of HTML. We have made different pages from home to payment page & the whole website have different functionalities and simple UI.
			</p>
		),
		tools: ['HTML', 'CSS' ,'JavaScript','localStorage'],
		link: "https://sparkling-alfajores-1bb3d8.netlify.app/",
		github: "https://github.com/Anmolroan/Zara-website",
		images: {
			sm: require(`assets/images/${images.zara}.jpg`),
			md: require(`assets/images/${images.zara}.jpg`),
			lg: require(`assets/images/${images.zara}.jpg`),
		},
	},
	{
		name: "Coursera Clone",
		description: (
			<p>
			Coursera is a global online learning platform that offers anyone, anywhere, access to online courses.  cloned this Website for learning purpose in Unit 3 of my Masai School curriculum with the help of 5 other team members
			</p>
		),
		tools: ['HTML', 'CSS' ,'JavaScript','Json Mock-server','localStorage'],
		link: "https://anmolroan.github.io/Coursera/",
		github: "https://github.com/Anmolroan/Coursera",
		images: {
			sm: require(`assets/images/${images.coursera}.jpg`),
			md: require(`assets/images/${images.coursera}.jpg`),
			lg: require(`assets/images/${images.coursera}.jpg`),
		},
	},
	{
		name: "Coursera clone with Backend",
		description: (
			<p>
				This is collaborative project which consist of Backend as well, We follow MVC model there to show our web pages, and for creating database We use mongoDB, for connecting mongoDb to the express we use Mongoose. And for backend we used Express in this project. After this project we got a clear picture around backend of the website like how data is stored in API how to receive data in the view part and render on the webpage",
			</p>
		),
		tools: [ 'HTML', 'CSS' ,'JavaScript','Mongodb', 'Express','NodeJs'],
		link: "https://happy-albattani-fcfa76.netlify.app/",
		github: "https://github.com/DharmeshRS/coursera",
		images: {
			sm: require(`assets/images/${images.coursera}.jpg`),
			md: require(`assets/images/${images.coursera}.jpg`),
			lg: require(`assets/images/${images.coursera}.jpg`),
		},
		
	},
	{
		name: "Beatuy-Bebo.com",
		description: (
			<p>
				 BeautyBebo is India’s fastest growing online retail store . I have cloned this website using react, Redux and express and mongodb.
			</p>
		),
		tools: ['REACT','REDUX','MONGODB','EXPRESS','NODE','TAILWIND','CHAKRA UI'],
		link: "https://gregarious-torrone-5fd17f.netlify.app/",
		github: "https://github.com/Anmolroan/Beauty-Bebo",
		images: {
			sm: require(`assets/images/${images.beautybebo}.jpg`),
			md: require(`assets/images/${images.beautybebo}.jpg`),
			lg: require(`assets/images/${images.beautybebo}.jpg`),
		},
	},
	
	

];



export const Social = [
	{
		link: "https://github.com/anmolroan",
		icon: <GitHub />,
		title: "GitHub ",
	},
	
	{
		link: "https://www.linkedin.com/in/anmolroan/",
		icon: <Linkedin />,
		title: "Linkedin ",
	},
	{
		link: "https://www.instagram.com/anmolroan/",
		icon: <Instagram />,
		title: "Instagram ",
	},
	{
		link: "https://twitter.com/anmolcoder",
		icon: <Twitter />,
		title: "Twitter",
	},
];
